module.exports = __webpack_public_path__ + "assets/fa45d86961a7054bf309ea59d3654057.png";